import { render } from "./Suppliers.vue?vue&type=template&id=679633a8&scoped=true"
import script from "./Suppliers.vue?vue&type=script&lang=ts"
export * from "./Suppliers.vue?vue&type=script&lang=ts"

import "./Suppliers.vue?vue&type=style&index=0&id=679633a8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-679633a8"

export default script